import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './modules/single-optimize/i18nSetup';
// C-42: registers the Phase-8 agent tool bundle (data.candidates.list /
// data.jobs.list / data.requisitions.list) with `toolRegistry` exactly
// once per session. Must run before any agent surface mounts.
import './modules/agent/tools';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
